import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Card, Button, Divider, message, Space, Typography, Form, Radio, Empty } from "antd";
import { StarOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { AuthContext } from "../../../contexts/AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFaceFrown, faFaceLaugh, faFaceMeh, faFaceSmile } from "@fortawesome/free-regular-svg-icons";
import http from "../../../services/http";
const { Text } = Typography;

const colors = {
  ["Ruim"]: "#ff5d5e",
  ["Regular"]: "#fbb74a",
  ["Bom"]: "#86d18c",
  ["Ótimo"]: "#4bb351",
};

const SatisfacaoFormulariosLancamento = () => {
  const [loading, setLoading] = useState();
  const { session, atualizarFormularios, encerrarSessao } = useContext(AuthContext);
  const [form] = Form.useForm();
  const questoes = Form.useWatch("questoes", form);

  // DADOS
  const [dados, setDados] = useState([]);

  useEffect(() => {
    if (session?.formularios_pendentes.length > 0) {
      carregarFormulario(session?.formularios_pendentes[0]);
    }
  }, [session.formularios_pendentes]);

  const realizarLogout = async () => {
    await http("get", "v1/autenticacao/logout", []);
    message.success("Logout realizado com sucesso!");
    await encerrarSessao();
  };

  // CARREGAR
  const carregarFormulario = async (id) => {
    setLoading(true);
    const api = await http("get", `v1/satisfacao_formularios/carregar_lancamento/${id}`, []);
    if (api.statusCode === 200) {
      if (!api.response.data) {
        atualizarFormularios(session?.formularios_pendentes?.filter((e) => e !== id));
      }
      setDados(api.response.data);
    } else if (api.statusCode === 403) {
      message.error(api.response.message);
      atualizarFormularios(session?.formularios_pendentes?.filter((e) => e !== id));
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // SALVAR
  const salvarFormulario = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/satisfacao_formularios/salvar_lancamento`, formulario);
    if (api.statusCode === 200) {
      message.success("Pesquisa realizada com sucesso!");
      if (session?.formularios_pendentes?.length > 0) {
        atualizarFormularios(
          session?.formularios_pendentes?.filter((e) => e !== formulario.id_satisfacao_cad_formularios)
        );
      }
    } else if (api.statusCode === 403) {
      message.error(api.response.message);
      atualizarFormularios(
        session?.formularios_pendentes?.filter((e) => e !== formulario.id_satisfacao_cad_formularios)
      );
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  const onSubmit = (formulario) => {
    formulario.id_satisfacao_cad_formularios = dados?.id;

    // SALVAR
    salvarFormulario(formulario);
  };

  const RenderEmojis = ({ style, name }) => {
    const emojis = {
      ["Ruim"]: <FontAwesomeIcon icon={faFaceFrown} style={style} />,
      ["Regular"]: <FontAwesomeIcon icon={faFaceMeh} style={style} />,
      ["Bom"]: <FontAwesomeIcon icon={faFaceSmile} style={style} />,
      ["Ótimo"]: <FontAwesomeIcon icon={faFaceLaugh} style={style} />,
    };

    return emojis[name];
  };

  const Complemento = ({ questao }) => {
    if (!questoes || Object.keys(questoes)?.length === 0) return;
    const alternativa = questao?.alternativas?.filter((e) => e.id === questoes[questao?.id]);
    if (alternativa?.length > 0 && alternativa[0]?.complemento === 1 && alternativa[0]?.complementos?.length > 0) {
      return (
        <Col className="gutter-row" xs={24} sm={24} md={24} lg={24} xl={24}>
          <Form.Item
            name={[`complementos`, `${alternativa[0]?.id}`]}
            label={`${alternativa[0]?.descricao_complemento}`}
            rules={[{ required: true, message: "Selecione uma opção!" }]}>
            <Radio.Group size="large">
              <Space direction="vertical">
                {alternativa[0]?.complementos?.map((comp) => (
                  <Radio key={comp?.id} value={comp?.id}>
                    {comp?.descricao}
                  </Radio>
                ))}
              </Space>
            </Radio.Group>
          </Form.Item>
        </Col>
      );
    }
  };

  const renderFormulario = () => {
    return (
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Form name="login" onFinish={onSubmit} layout="vertical" form={form} style={{ width: "100%" }}>
          {dados?.questoes?.map((quest) => {
            return (
              <React.Fragment key={quest?.id}>
                <Col className="gutter-row" xs={24} sm={24} md={24} lg={24} xl={24} align="center">
                  <Text strong style={{ fontSize: 20 }}>
                    {quest?.descricao}
                  </Text>
                  <br />
                  <br />
                  <br />
                  <Form.Item
                    name={["questoes", `${quest?.id}`]}
                    rules={[{ required: true, message: "Selecione uma alternativa!" }]}>
                    <Radio.Group size="large">
                      {quest?.alternativas?.map((alt) => (
                        <Radio style={{ marginBottom: 10 }} key={alt?.id} value={alt?.id} className="radio-rate">
                          <Space direction="vertical">
                            <RenderEmojis
                              style={{
                                fontSize: 80,
                                color:
                                  Object.keys(questoes ?? {})?.length > 0 &&
                                  (questoes[`${quest?.id}`] === alt?.id ? colors[alt?.descricao] : "#cbcbcb"),
                              }}
                              name={alt?.descricao}
                            />
                            <Text
                              strong
                              style={{
                                fontSize: 16,
                                color:
                                  Object.keys(questoes ?? {})?.length > 0 &&
                                  (questoes[`${quest?.id}`] === alt?.id ? colors[alt?.descricao] : "#cbcbcb"),
                              }}>
                              {alt?.descricao}
                            </Text>
                          </Space>
                        </Radio>
                      ))}
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Complemento questao={quest} />
                <Divider />
              </React.Fragment>
            );
          })}
          <Col className="gutter-row" span={24} align="center">
            <Button onClick={() => form.submit()} size="large" type="primary" loading={loading}>
              Confirmar
            </Button>
          </Col>
        </Form>
      </Row>
    );
  };
  // VAZIO
  const renderEmpty = () => {
    return (
      <div className="center">
        <Empty />
      </div>
    );
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={20} xl={20} xxl={14} align="left" className="content-item">
          <HeaderPage title="Pesquisa de Satisfação" backText="Sair" onClickBack={realizarLogout} />
          <HeaderTitle
            title="Pesquisa de Satisfação"
            subtitle={dados?.descricao}
            icon={<StarOutlined />}
            loading={loading}
          />
          <Divider />
          <Card bordered={false} bodyStyle={{ padding: "3%" }}>
            {loading || !dados.id ? renderEmpty() : renderFormulario()}
          </Card>
        </Col>
      </Col>
    </Row>
  );
};

export default SatisfacaoFormulariosLancamento;
